import { hot } from 'react-hot-loader/root'

import AppContainer from './AppContainer'

export default hot(AppContainer)